import { Link } from 'react-router-dom'
import { Button } from '@mui/material'
import React from 'react'
import { useTheme } from '../../../../utils/themeContext'
import { getColorsForTheme } from '../../../../global-styles/clientColors'

const VehicleDetailCell = (props) => {
  const {
    id,
    from = 'listings',
  } = props

  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)

  return (
    <Link to={`/view/${from}/${id}`} style={{ textDecoration: 'none' }}>
      <Button
        color='secondary'
        variant='contained'
        sx={{
          backgroundColor: themeColors.buttonColor,
          color: currentTheme === 'galpin' ? 'black' : 'white',
          '&:hover': {
            backgroundColor: themeColors.buttonHover,
          },
        }}
      >
        View
      </Button>
    </Link>
  )
}

export default VehicleDetailCell
